import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UpdateBlacklistElementMutation,
  UpdateBlacklistElementMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";

export const updateBlacklistElementMutation = gql`
  mutation UpdateBlacklistElement($id: ID!, $properties: [PropertyValueInput!]!) {
    updateBlacklistElement(id: $id, options: { properties: $properties }) {
      id
    }
  }
` as TypedDocumentNode<UpdateBlacklistElementMutation, UpdateBlacklistElementMutationVariables>;
